module.exports = __webpack_public_path__ + "img/location.f4c1ffe3.svg";